module.exports = __webpack_public_path__ + "img/744.62c1abc8.jpg";